module.exports = __webpack_public_path__ + "assets/img/31-s.321dd77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/31-s.jpg
// module id = QSvC
// module chunks = 0